<template>
    <AppModal name="confirm-action-modal" :beforeOpen="beforeOpen" :onEnterKeyPress="confirm">
        <template slot="header">
            {{ title }}
        </template>
        <template slot="content">
            <div v-html="description" class="font-16"></div>
        </template>
        <template slot="actions">
            <button @click="cancel"
                    v-loading.btn="isCanceling"
                    class="btn btn-link">
                {{ cancelBtnText }}
            </button>
            <button @click="confirm"
                    v-loading.btn="isConfirming"
                    class="btn btn-danger mt-3">
                {{ confirmBtnText }}
            </button>
            <br>
            <template  v-if="extraButtons.length !== 0">
                <button v-for="(btn, idx) in extraButtons" :key="idx" @click="runExtraBtnAction(idx)"
                        v-loading.btn="btn.isLoading"
                        class="btn btn-link mt-3">
                    {{ btn.text }}
                </button>
            </template>
        </template>
    </AppModal>
</template>

<script>
export default {
    name: 'ConfirmActionModal',
    data() {
        return {
            title: null,
            description: null,
            onConfirm: null,
            onCancel: null,
            confirmBtnText: null,
            cancelBtnText: null,

            isCanceling: false,
            isConfirming: false,

            extraButtons: []
        }
    },
    methods: {
        beforeOpen({params}) {
            this.title = params.title
            this.description = params.description
            this.onConfirm = params.onConfirm
            this.onCancel = params.onCancel
            this.confirmBtnText = params.confirmBtnText
            this.cancelBtnText = params.cancelBtnText

            this.extraButtons = params.extraButtons || []
            if (this.extraButtons.length !== 0) {
                this.extraButtons.forEach((_, idx) => {
                    this.$set(this.extraButtons[idx], 'isLoading', false)
                })
            }
        },

        async confirm() {
            if (typeof this.onConfirm === 'function') {
                this.isConfirming = true
                await this.onConfirm()
                this.isConfirming = false
            }
            this.closeModal()
        },

        async cancel() {
            if (typeof this.onCancel === 'function') {
                this.isCanceling = true
                await this.onCancel()
                this.isCanceling = false
            }
            this.closeModal()
        },

        async runExtraBtnAction(idx) {
            if (!this.extraButtons[idx]) {
                return
            }
            if (typeof this.extraButtons[idx].action === 'function') {
                this.$set(this.extraButtons[idx], 'isLoading', true)
                await this.extraButtons[idx].action()
                this.$set(this.extraButtons[idx], 'isLoading', false)
            }
            this.closeModal()
        },

        closeModal() {
            this.$modal.hide('confirm-action-modal')
        }
    }
}
</script>

<style scoped>
    button {
        min-width: 120px;
    }
</style>
